import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	emptyQueryMessage: {
		id: 'base-user-picker.empty-query-message',
		defaultMessage: 'Start typing to get a list of possible matches.',
		description: 'Message when query is empty',
	},
});
